import {Component, ref} from 'vue'

const dynamicComponent = ref()
const dynamicProps = ref()
const dynamicHandlers = ref()

const useDynamicComponentLoader = () => {
    return {
        loadComponent: (component: Component, props = {}, handlers = {}) => {
            dynamicComponent.value = component
            dynamicProps.value = props
            dynamicHandlers.value = handlers
        },
        clearDynamicComponent: () => {
            dynamicComponent.value = undefined
            dynamicProps.value = {}
            dynamicHandlers.value = {}
        },
        dynamicComponent,
        dynamicProps,
        dynamicHandlers
    }
}

export default useDynamicComponentLoader